import React from "react";
import "./ConfirmDeleteModal.css";

export default function InfoModal({ title = "Información", message = "", onClose, actionLabel = "Entendido" }) {
  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="info-modal-title">
      <div className="modal-box">
        <h2 id="info-modal-title">{title}</h2>
        {message && <p>{message}</p>}
        <div className="modal-actions" style={{ justifyContent: "center" }}>
          <button onClick={onClose}>{actionLabel}</button>
        </div>
      </div>
    </div>
  );
}

